export default "__VITE_ASSET__B$82rkok__"